/**
 * Internal dependencies
 */
import {
    CURRENT_TSPAY_RECEIVE,
    CURRENT_TSPAY_REQUEST,
    CURRENT_TSPAY_REQUEST_SUCCESS,
    CURRENT_TSPAY_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentTsPay, requestingCurrentTsPay} from 'state/current-tspay/selectors';

/**
 * [description]
 *
 * @param  {[type]} tsPay [description]
 * @return {[type]}         [description]
 */
export const setCurrentTsPay = (tsPay) => {
    return {
        type: CURRENT_TSPAY_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentTsPay = () => (dispatch) => {
    dispatch({
        type: CURRENT_TSPAY_REQUEST,
    });

    return cscom
        .currentTsPay()
        .list()
        .then((tsPay) => {
            dispatch({
                type: CURRENT_TSPAY_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_TSPAY_RECEIVE,
                payload: {
                    tsPay,
                },
            });
            return tsPay;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_TSPAY_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_TSPAY_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 *
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentTsPayIfNotRequested = (...props) => async (dispatch, getState) => {

    const currentTsPay = getCurrentTsPay(getState());
    const requesting = requestingCurrentTsPay(getState());

    if (!currentTsPay && requesting == false) {
        return dispatch(requestCurrentTsPay(...props))
    }

    return currentTsPay;
}
